import PropTypes from 'prop-types';
import React from 'react';
import Translation from '../../../i18n/Translation';

const PaymentMethodBalanceFailed = ({ balance }) => (
  <div className="withdraw-failed__details">
    <p className="withdraw-failed__paragraph">
      {balance === 0
        ? <Translation section="withdraw" label="noAvailableShopBalance" />
        : (
          <Translation
            section="withdraw"
            label="availableShopBalance"
            variables={{ amount: balance.toFixed(2) }}
          />
        )}
    </p>
    <p className="withdraw-failed__paragraph">
      <Translation section="withdraw" label="withdrawRemainingFunds" />
    </p>
    <p className="withdraw-failed__paragraph">
      <Translation section="withdraw" label="contactCustomerRelations" />
    </p>
    <p className="withdraw-failed__paragraph">
      <Translation section="withdraw" label="retailSupportEmail" />
    </p>
    <p className="withdraw-failed__paragraph">
      <Translation section="withdraw" label="retailSupportPhone" />
    </p>
  </div>
);

PaymentMethodBalanceFailed.propTypes = {
  balance: PropTypes.number.isRequired
};

export default PaymentMethodBalanceFailed;
